module.exports = __webpack_public_path__ + "img/Uppdraget.13852eb3.jpg";